// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"18301312","194":"987ddd7d","453":"801d3fed","594":"3b5c8678"}[chunkId] + ".chunk.js";
};